import Sync from "@mui/icons-material/Sync";
import { Box } from "@mui/material";
import { useWeekViewContext } from "../../../contexts/WeekView";
import { useSchedulePersonName } from "../../../hooks/useSchedulePersonName";
import type { NurseInShift } from "../../../utils/models";
import { NurseStatusIcons } from "../../NurseStatusIcons/NurseStatusIcons";

type Props = {
	nurseInShift: NurseInShift;
};

export const NurseInShiftMainText = ({ nurseInShift }: Props) => {
	// The week's own people, so the row's name and icons show before the roster loads.
	const person = useWeekViewContext().getSchedulePerson(nurseInShift.nurseId);
	const personName = useSchedulePersonName();
	return (
		<Box
			sx={{
				display: "flex",
				alignItems: "center",
				gap: 0.5,
				justifyContent: "start",
			}}
		>
			{personName(nurseInShift.nurseId)}
			<NurseStatusIcons person={person} charge={nurseInShift.charge} trainingStatus={nurseInShift.trainingStatus} />
			{nurseInShift.recurringShiftId != null && <Sync fontSize={"inherit"} />}
		</Box>
	);
};
